import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import { ErrorHandler } from '../lib/ErrorHandler';
const CallbackContext = createContext(undefined);
export function CallbackProvider({ children, callbacks }) {
    const value = useMemo(() => {
        return {
            onFormChange: (formData) => { try {
                callbacks?.onFormChange?.(formData);
            }
            catch (error) {
                ErrorHandler(error);
            } },
            onSwapCreate: (swapData) => { try {
                callbacks?.onSwapCreate?.(swapData);
            }
            catch (error) {
                ErrorHandler(error);
            } },
            onSwapComplete: (swapData) => { try {
                callbacks?.onSwapComplete?.(swapData);
            }
            catch (error) {
                ErrorHandler(error);
            } },
            onSwapModalStateChange: (open) => { try {
                callbacks?.onSwapModalStateChange?.(open);
            }
            catch (error) {
                ErrorHandler(error);
            } },
            onBackClick: () => { try {
                callbacks?.onBackClick?.();
            }
            catch (error) {
                ErrorHandler(error);
            } },
            onError: (error) => { try {
                callbacks?.onError?.(error);
            }
            catch (error) {
                ErrorHandler(error);
            } },
            onSwapStatusChange: (event) => { try {
                callbacks?.onSwapStatusChange?.(event);
            }
            catch (error) {
                ErrorHandler(error);
            } },
            onMenuNavigationChange: (path) => { try {
                callbacks?.onMenuNavigationChange?.(path);
            }
            catch (error) {
                ErrorHandler(error);
            } },
        };
    }, [callbacks]);
    return (_jsx(CallbackContext.Provider, { value: value, children: children }));
}
export function useCallbacks() {
    const context = useContext(CallbackContext);
    if (!context) {
        throw new Error('useCallbacks must be used within a CallbackProvider');
    }
    return context;
}
